"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemContainer = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var OptimisticAsyncObservable_1 = require("icf-search-client-shared/lib/observables/OptimisticAsyncObservable");
var Events_1 = require("icf-search-client-shared/lib/services/Events");
var RecommenderSession_1 = require("icf-search-client-shared/lib/services/RecommenderSession");
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var SinglePendingAsync_1 = require("icf-search-client-shared/lib/SinglePendingAsync");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var Contexts_1 = require("../Contexts");
var VisibleItemsContext_1 = require("../core/list/VisibleItemsContext");
var Ioc_1 = require("../utilities/Ioc");
var PerformerDataSourceContextProps_1 = require("./PerformerDataSourceContextProps");
var PerformerItem_1 = require("./PerformerItem");
var SearchResultsGridHelpers_1 = require("./SearchResultsGridHelpers");
var PerformerItemContainer = /** @class */ (function (_super) {
    __extends(PerformerItemContainer, _super);
    function PerformerItemContainer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._singleFavoriteToggleAsync = new SinglePendingAsync_1.SinglePendingAsync();
        _this._isUnmounted = false;
        _this._updateRemovalExclusionState = function (shouldExclude) {
            var _a = _this.props, performerData = _a.performerData, itemRemovalExclusion = _a.itemRemovalExclusion;
            if (!performerData || !performerData.hasDetails) {
                return;
            }
            if (shouldExclude) {
                itemRemovalExclusion.add(performerData.id);
            }
            else {
                itemRemovalExclusion.remove(performerData.id);
            }
        };
        _this._performerClicked = function () {
            var _a, _b, _c, _d;
            var _e = _this.props, skinConfig = _e.skinConfig, emitTrackingEvent = _e.emitTrackingEvent, dataQueryOptions = _e.dataQueryOptions, itemIndex = _e.itemIndex, dataSource = _e.dataSource, eventPublisher = _e.eventPublisher, statsdClient = _e.statsdClient, user = _e.user;
            var performerData = _this.state.performerData;
            if (!performerData || !performerData.hasDetails) {
                return;
            }
            var metaData = "rank=".concat(dataSource.itemRange.value.start + itemIndex);
            var loggedOutRec = (_a = (0, RecommenderSession_1.getRecommenderSession)()) === null || _a === void 0 ? void 0 : _a.experimentName;
            if (loggedOutRec !== null) {
                metaData += "&loggedoutrec=" + loggedOutRec;
                metaData += "&variation=" + loggedOutRec; // TODO: Make sure things work for loggedinrec
            }
            metaData += "&performerId=".concat(performerData.id);
            metaData +=
                "&searchQueryData=" +
                    // TODO: Verify that these are valid fallbacks
                    (0, SearchResultsGridHelpers_1.getSearchQueryDataForTracking)({
                        index: dataSource.resultsContext.value.requestedIndex,
                        // Removing this check didn't throw apparently, but caused test to fail on emitting tracking event?
                        // Possibly random
                        isUserLoggedIn: !!user && user.isAuthenticated,
                        queryOptions: dataQueryOptions,
                        siteId: (_b = skinConfig.global.site) !== null && _b !== void 0 ? _b : -1,
                        from: dataSource.itemRange.value.start,
                        size: dataSource.itemRange.value.end - dataSource.itemRange.value.start,
                    });
            if (emitTrackingEvent) {
                emitTrackingEvent("icfClick", "PerformerGridItem", metaData);
            }
            // session storage here
            (_d = (_c = _this.props).onGridClick) === null || _d === void 0 ? void 0 : _d.call(_c, performerData.id.toString());
            var visibleItemsState = _this.props.visibleItemsContext.visibleItemsState.value;
            var eventContext = {
                fallback: dataSource.resultsContext.value.isFallback,
                searchResultPosition: dataSource.itemRange.value.start + itemIndex,
                liveState: performerData.liveState,
                online: performerData.online,
                performerId: performerData.id,
                searchDataOptions: (0, PerformerDataSourceContextProps_1.prepareTrackingQueryOptions)(dataQueryOptions),
                visibleRange: visibleItemsState.range,
            };
            if (eventPublisher) {
                eventPublisher.send(Events_1.Events.performerItemClick, eventContext, undefined, false);
                (0, RecommenderSession_1.sendRecommenderSessionEvent)("gridClicked");
            }
            statsdClient && statsdClient.count("performerItem.click");
        };
        _this._updateState = function () {
            // TODO: Contest performers never have a state update, but leaving this here for now
            /* istanbul ignore if */
            if (!_this.state.performerData || !_this.state.performerData.hasDetails) {
                return;
            }
            return _this.props.dataSource.requestDataUpdate(_this.state.performerData);
        };
        _this._onPreviewError = function () { return __awaiter(_this, void 0, void 0, function () {
            var statsdClient, oldPerformerState, newData, newPerformerState;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        statsdClient = this.props.statsdClient;
                        oldPerformerState = ((_a = this.state.performerData) === null || _a === void 0 ? void 0 : _a.hasDetails)
                            ? this.state.performerData.liveState
                            : this.state.performerData;
                        return [4 /*yield*/, this._updateState()];
                    case 1:
                        newData = _b.sent();
                        newPerformerState = (newData === null || newData === void 0 ? void 0 : newData.hasDetails) ? newData.liveState : newData;
                        // TODO: Can this comparison break if there's a mismatch between response object property order?
                        // if we hit an error, did an update, and the state has not changed, it is considered to be stale
                        if (JSON.stringify(oldPerformerState) === JSON.stringify(newPerformerState)) {
                            if (statsdClient) {
                                this.props.statsdClient.count("performerItem.staleState");
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this._toggleFavorite = function () {
            /* istanbul ignore if */
            if (!_this.state.performerData || !_this.state.performerData.hasDetails) {
                return;
            }
            var performerId = _this.state.performerData.id;
            var newValue = !_this.state.performerData.favorite;
            // Update the optimistic value with our updated favorite property:
            _this._optimisticPerformerData.update({ favorite: newValue }, function (onCancelled) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        // Enqueue an async action to do the actual update. This might be skipped if the user taps multiple times.
                        return [4 /*yield*/, this._singleFavoriteToggleAsync.execute(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: 
                                        // Perform the actual service call:
                                        return [4 /*yield*/, this.props.favoritePerformersService.setPerformerFavoriteState(performerId, newValue)];
                                        case 1:
                                            // Perform the actual service call:
                                            _a.sent();
                                            /* istanbul ignore if */
                                            if (this._isUnmounted) {
                                                return [2 /*return*/];
                                            }
                                            return [4 /*yield*/, (0, Utilities_1.delay)(100)];
                                        case 2:
                                            _a.sent();
                                            // Now, we request updated state for the performer. This is the same update we use for when
                                            // the user hovers, but the stream fails to start.
                                            return [4 /*yield*/, this._updateState()];
                                        case 3:
                                            // Now, we request updated state for the performer. This is the same update we use for when
                                            // the user hovers, but the stream fails to start.
                                            _a.sent();
                                            return [4 /*yield*/, (0, Utilities_1.delay)(100)];
                                        case 4:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, onCancelled)];
                        case 1:
                            // Enqueue an async action to do the actual update. This might be skipped if the user taps multiple times.
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this._onFavoriteIconClicked = function (performerData) {
            var _a, _b, _c, _d, _e, _f, _g;
            /* istanbul ignore next -- would require entire test suite with user as undefined instead of present and offline, but it's unclear if it is ever the case */
            if ((_a = _this.props.user) === null || _a === void 0 ? void 0 : _a.isAuthenticated) {
                _this.props.favoritePerformersService && _this._toggleFavorite();
                return;
            }
            if (((_b = _this.props.xmentService) === null || _b === void 0 ? void 0 : _b.getXmentVariation(XmentService_1.JOIN_CTA_GO_TO_JOIN_PAGE_MOBILE)) === "B" ||
                ((_c = _this.props.xmentService) === null || _c === void 0 ? void 0 : _c.getXmentVariation(XmentService_1.JOIN_CTA_GO_TO_JOIN_PAGE_DESKTOP)) === "B") {
                (_e = (_d = _this.props).openJoinPage) === null || _e === void 0 ? void 0 : _e.call(_d, performerData);
                return;
            }
            (_g = (_f = _this.props).openJoinModal) === null || _g === void 0 ? void 0 : _g.call(_f, performerData);
        };
        _this.state = {
            performerData: props.performerData,
            disableSnapshot: _this.getDisableSnapshotState(props.performerData),
        };
        return _this;
    }
    PerformerItemContainer.prototype.getDisableSnapshotState = function (performerData) {
        var _a, _b, _c, _d, _e;
        var isLoggedOutOrFreemium = !((_a = this.props.user) === null || _a === void 0 ? void 0 : _a.isAuthenticated) || ((_b = this.props.user) === null || _b === void 0 ? void 0 : _b.isFreemium);
        return (((_c = this.props.dataQueryOptions) === null || _c === void 0 ? void 0 : _c.type) === "favorites" ||
            ((performerData === null || performerData === void 0 ? void 0 : performerData.hasDetails) && performerData.forceBiopic) ||
            /* istanbul ignore next -- would require entire test suite with user as undefined instead of present and offline, but it's unclear if it is ever the case */
            (((_d = this.props.user) === null || _d === void 0 ? void 0 : _d.requiresAgeConfirmation) && isLoggedOutOrFreemium) ||
            /* istanbul ignore next -- would require entire test suite with user as undefined instead of present and offline, but it's unclear if it is ever the case */
            !((_e = this.props.user) === null || _e === void 0 ? void 0 : _e.isAuthenticated));
    };
    PerformerItemContainer.prototype.componentDidMount = function () {
        var _this = this;
        this._optimisticPerformerData = new OptimisticAsyncObservable_1.OptimisticAsyncObservable(this.props.performerData);
        this._optimisticPerformerData.subscribe(function (performerData) {
            _this.setState({ performerData: performerData });
        });
    };
    PerformerItemContainer.prototype.componentDidUpdate = function () {
        this._optimisticPerformerData.setBaseValue(this.props.performerData);
        this.setState({
            disableSnapshot: this.getDisableSnapshotState(this.props.performerData),
        });
    };
    PerformerItemContainer.prototype.componentWillUnmount = function () {
        this._isUnmounted = true;
        this._updateRemovalExclusionState(false);
        this._optimisticPerformerData.dispose();
    };
    PerformerItemContainer.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return (React.createElement(PerformerItem_1.PerformerItem, { "data-ta-locator": "performer_item", disableSnapshots: !!this.state.disableSnapshot, emitTrackingEvent: this.props.emitTrackingEvent, getPerformerLinkTo: this.props.getPerformerLinkTo, imageBucket: this.props.imageBucket, isLoggedIn: (_a = this.props.user) === null || _a === void 0 ? void 0 : _a.isAuthenticated, isLogoVerified: this.props.isLogoVerified, isMobile: this.props.isMobile, isPreviewEnabled: 
            /* istanbul ignore next -- would require entire test suite with user as undefined instead of present and offline, but it's unclear if it is ever the case */
            ((_b = this.props.user) === null || _b === void 0 ? void 0 : _b.isAuthenticated) && !(((_c = this.props.user) === null || _c === void 0 ? void 0 : _c.isFreemium) && ((_d = this.props.user) === null || _d === void 0 ? void 0 : _d.requiresAgeConfirmation)), isThumbnailBlurred: 
            /* istanbul ignore next -- would require entire test suite with user as undefined instead of present and offline, but it's unclear if it is ever the case */
            ((_e = this.props.user) === null || _e === void 0 ? void 0 : _e.requiresAgeConfirmation) && (!((_f = this.props.user) === null || _f === void 0 ? void 0 : _f.isAuthenticated) || ((_g = this.props.user) === null || _g === void 0 ? void 0 : _g.isFreemium)), isSoundEnabled: this.props.isSoundEnabled, onClick: this._performerClicked, onFavoriteIconClicked: this._onFavoriteIconClicked, onIsHoveringChanged: this._updateRemovalExclusionState, onNotifyClicked: this.props.onNotifyClicked, onPreviewError: this._onPreviewError, performerData: this.state.performerData, userData: this.props.user, showHeadlines: this.props.showHeadlines, skinConfig: this.props.skinConfig, statsdClient: this.props.statsdClient, swapRollovers: this.props.swapRollovers }));
    };
    PerformerItemContainer = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            skinConfig: Contexts_1.ISearchSkinConfigContext,
            imageBucket: Contexts_1.IImageBucketContext,
            // @ts-ignore -- Fix typing for contexts with undefined
            eventPublisher: Contexts_1.IEventPublisherContext,
            visibleItemsContext: VisibleItemsContext_1.IVisibleItemsContextContext,
            itemRemovalExclusion: Contexts_1.IItemRemovalExclusionContext,
            favoritePerformersService: Contexts_1.IFavoritePerformersServiceContext,
            user: Contexts_1.IUserContext,
            // @ts-ignore -- Fix typing for contexts with undefined
            statsdClient: Contexts_1.IStatsdClientContext,
            xmentService: Contexts_1.IXmentServiceContext,
            searchApiClientFactory: Contexts_1.ISearchApiClientFactoryContext,
        })
    ], PerformerItemContainer);
    return PerformerItemContainer;
}(React.PureComponent));
exports.PerformerItemContainer = PerformerItemContainer;
//# sourceMappingURL=PerformerItemContainer.js.map